import React from 'react';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';

import { Touchable } from '../common/Touchable';
import { Image } from '../common/Image';
import { BaseText } from '../common/BaseText';
import { AvatarImage } from '../common/AvatarImage';
import { Separator } from '../common/Separator';
import { Track } from '@models/Tracks/TrackModel';
import { createAspectRatioStyles } from '@styles';

interface ITouchableContainerStyleProps {
  width?: number;
}

const TouchableContainer = styled(Touchable)(
  (props: ITouchableContainerStyleProps) => ({
    flex: 1,
    width: props.width,
  }),
);

interface ITrackImageStyleProps {
  size?: number;
}

const TrackImage = styled(Image)((props: ITrackImageStyleProps) => ({
  ...createAspectRatioStyles(1, props.size ?? '100%'),
  borderRadius: 12,
  bg: '$background20',
}));

const Title = styled(BaseText)({
  variant: 'text.large',
  fontWeight: 'semi',
  color: '$heading800',
});

const RowContainer = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
});

const UsernameText = styled(BaseText)({
  ml: '$4',
  variant: 'text.small',
  color: '$text100',
});

interface ITrackItemProps {
  item: Track;
  width?: number;
  onPress(item: Track): void;
}

export const TrackItem = observer<ITrackItemProps>(
  ({ item, width, onPress }) => {
    return (
      <TouchableContainer width={width} onPress={() => onPress(item)}>
        <TrackImage
          source={{ uri: item.cover }}
          size={width}
          contentFit="cover"
        />
        <Separator size={['$4', '$5']} />
        <Title numberOfLines={1}>{item.title}</Title>
        <Separator size="$4" />
        <RowContainer>
          <AvatarImage
            source={{
              uri: item.user.photo.thumbnail?.src,
            }}
            size={28}
          />
          <UsernameText>{item.user.fullName}</UsernameText>
        </RowContainer>
      </TouchableContainer>
    );
  },
);
